import React, { FC } from 'react';
import cx from 'classnames';
import './input.css';

export const INPUT_COLORS = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
};

export const INPUT_VARIANTS = {
  OUTLINE: 'outline',
  FILL: 'fill',
};

export type Props = React.InputHTMLAttributes<HTMLInputElement> & {
  color?: string;
  variant?: string;
  variantFill?: boolean;
  isFillWhenCustomerHover?: boolean;
  isError?: boolean;
};

const Input: FC<Props> = ({
  variant = INPUT_VARIANTS.OUTLINE,
  color = INPUT_COLORS.PRIMARY,
  variantFill,
  isFillWhenCustomerHover = false,
  className,
  ...rest
}) => (
  <input
    {...rest}
    className={cx(
      'pb-input',
      {
        'pb-input-primary': color === INPUT_COLORS.PRIMARY,

        'pb-input-variant-outline':
          !variantFill && variant === INPUT_VARIANTS.OUTLINE,
        'pb-input-variant-fill': variantFill || variant === INPUT_VARIANTS.FILL,

        'pb-input-fill-when-active': !rest?.disabled && isFillWhenCustomerHover,
        'pb-input-disabled': !!rest?.disabled,
        'pb-input-error': !!rest?.isError,
      },
      'text-pb-h1',
      className,
    )}
  />
);

export default Input;
